export const CFDI = [
  { label: "Adquisición de mercancias", code: "G01" },
  { label: "Gastos en general", code: "G03" },
  { label: "Equipo de computo y accesorios", code: "I04" },
  { label: "Por definir", code: "P01" },
];
